import React, { useEffect, useState } from "react";

function diff(deadline) {
  const now = new Date();
  const target = new Date(deadline);
  const ms = Math.max(0, target - now);
  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);
  return { days, hours, minutes, seconds, ms };
}

export default function Countdown({ deadline, compact = false }) {
  const [t, setT] = useState(() => (deadline ? diff(deadline) : null));

  useEffect(() => {
    if (!deadline) return;
    setT(diff(deadline));
    const id = setInterval(() => setT(diff(deadline)), 1000);
    return () => clearInterval(id);
  }, [deadline]);

  if (!deadline || !t) return null;
  const cells = [
    { v: t.days, l: "dias" },
    { v: t.hours, l: "horas" },
    { v: t.minutes, l: "min" },
    { v: t.seconds, l: "seg" },
  ];
  const pad = (n) => String(n).padStart(2, "0");

  if (t.ms === 0) {
    return (
      <div className="pm-card p-4 inline-block" data-testid="countdown-ended">
        <div className="pm-label text-[10px]">Pré-lançamento</div>
        <div className="font-mono text-lg mt-1">Encerrado</div>
      </div>
    );
  }

  return (
    <div className={compact ? "flex gap-2" : "grid grid-cols-4 gap-2 sm:gap-3"} data-testid="countdown">
      {cells.map((c) => (
        <div
          key={c.l}
          className={`pm-card ${compact ? "px-3 py-2" : "px-3 sm:px-4 py-3"} text-center`}
        >
          <div className={`font-mono font-bold pm-neon-text ${compact ? "text-lg" : "text-2xl sm:text-3xl"}`}>
            {pad(c.v)}
          </div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-white/50 mt-1">{c.l}</div>
        </div>
      ))}
    </div>
  );
}
